import React, { useState } from 'react'
import { useAlert } from 'react-alert'
import RightArrowIcon from '../../assets/icons/svgComponents/right-arrow-icon'
import MyAutoComplete from '../autocomplete'
import Button from '../button'
import * as S from './styles'
import { makeLoadConstruto } from '../../../main/usecases/load-construto/load-construto'
import { makeLoadTests } from '../../../main/usecases/load-tests/load-tests'
import { makeLoadTables } from '../../../main/usecases/load-tables/load-tables'

type Props={
  handleClick:()=>void
  data:{
    filtroDoConstruto:string
      tipoDeTeste:string
      tipoDeTabela: string,
      escolaridade?: string,
      sexo?: string,
      idade?: string,
      pontuação: string,
    }
    setData:any
}
type constructProps = {
  cdConstruto:string
  construto:string
}
type testProps = {
  cdConstruto:string
  construto:string
}
type ObjProps = {
  cd:string
  nome:string
}
type tableProps = {
  cdTipoDeTabela: string
  descricao: string
}

const FirstStep = ({
  handleClick, data, setData,
}:Props) => {
  const alert = useAlert()
  const [value1, setValue1] = useState('')
  const [value2, setValue2] = useState('')
  const [value3, setValue3] = useState('')
  const [options, setOptions] = useState< Array<ObjProps>>([])
  const [options1, setOptions1] = useState< Array<ObjProps>>([])
  const [options2, setOptions2] = useState< Array<ObjProps>>([])

  const loadFirstOption = async () => {
    const loadOptions:Array<constructProps> = await makeLoadConstruto().load()
    const auxOptions = loadOptions.map((construct) => {
      const constructList = (Object.values(construct))
      return ({
        cd: constructList[0],
        nome: constructList[1],
      }
      )
    })
    setOptions(auxOptions)
  }
  const loadSecondOption = async (selectedOption:string) => {
    try {
      const loadOptions:
    Array<tableProps> = selectedOption !== '' ? await makeLoadTests(`=${selectedOption}`).load()
      : await makeLoadTests('').load()
      const auxOptions = loadOptions.map((construct) => {
        const constructList = (Object.values(construct))
        return ({
          cd: constructList[0],
          nome: constructList[1],
        }
        )
      })
      setOptions1(auxOptions)
    } catch (error) {
      alert.show('Construto inválido')
    }
  }

  const loadThirdOption = async (selectedOption:string) => {
    try {
      const loadOptions:
    Array<testProps> = selectedOption !== '' ? await makeLoadTables(`=${selectedOption}`).load()
      : await makeLoadTables('').load()
      const auxOptions = loadOptions.map((construct) => {
        const constructList = (Object.values(construct))
        return ({
          cd: constructList[0],
          nome: constructList[1],
        }
        )
      })
      setOptions2(auxOptions)
      if (auxOptions.length === 1) {
        setValue3(auxOptions[0].nome)
        setData({ ...data, ...data, tipoDeTabela: auxOptions[0].cd })
      }
    } catch (error) {
      alert.show('Teste inválido')
    }
  }

  return (
    <S.Wrapper>
      <S.ProgressBar>
        <S.Progress stage={1} />
      </S.ProgressBar>
      <h1>Informações sobre o teste aplicado</h1>
      <h2>preencha os campos</h2>
      <form onSubmit={(e) => {
        e.preventDefault()
        handleClick()
      }}
      >
        <MyAutoComplete
          value={value1}
          setValue={setValue1}
          name="firstSelectFirstStep"
          label="Filtro de construto"
          labelColor="black"
          onMenuOpen={(e:any) => {
            if (e) { loadFirstOption() }
          }}
          onSelect={(e:any) => {
            setData({ ...data, filtroDoConstruto: e })
          }}
          options={options}
        />
        <MyAutoComplete
          value={value2}
          setValue={setValue2}
          name="secondSelectFirstStep"
          label="Selecione o teste*"
          labelColor="black"
          isRequired
          onMenuOpen={(e:any) => {
            if (e) {
              loadSecondOption(data.filtroDoConstruto)
            }
          }}
          onSelect={(e:any) => {
            loadThirdOption(e)
            setData({ ...data, tipoDeTeste: e })
          }}
          options={options1}
        />
        <MyAutoComplete
          isRequired
          value={value3}
          setValue={(e:any) => { setValue3(e.replace(/[0-9]+/, '')) }}
          name="thirdSelectFirstStep"
          label="Selecione o tipo de tabela*"
          labelColor="black"
          onSelect={(e:any) => {
            setData({ ...data, tipoDeTabela: e })
          }}
          options={options2}
        />
        <Button
          Thisclass="stepButton"
          type="submit"
          endIcon={<RightArrowIcon color="white" />}
        >
          Prosseguir

        </Button>
      </form>
    </S.Wrapper>
  )
}
export default FirstStep
